var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomePage',{attrs:{"regions":_vm.regions,"editorial":_vm.remark,"sdgall":_vm.sdg,"area":_vm.area}})}
var staticRenderFns = []

export { render, staticRenderFns }